import { editorPicks } from "@/mocks/manga";

export default function PicksSection() {
  return (
    <section id="picks" className="w-full bg-background-50 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-1.5 text-xs font-label text-primary-600 uppercase tracking-widest">
            <i className="ri-bookmark-3-line text-base" aria-hidden="true"></i>
            Editor&apos;s Picks
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            编辑精选：为什么我们推荐这三部
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            精选不做数量堆砌。这里只讲清楚一件事——它适合什么心情、什么口味的读者。
            如果你试读了几部都不对味，不妨从这几段手记里找找方向。
          </p>
        </div>

        <div className="mt-10 flex flex-col gap-6">
          {editorPicks.map((pick, index) => (
            <article
              key={pick.title}
              className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 p-5 md:p-6 rounded-lg bg-background-100/70 border border-background-200"
            >
              <div
                className={`md:col-span-4 flex gap-5 ${
                  index % 2 === 1 ? "md:order-2" : ""
                }`}
              >
                <div className="w-28 h-40 md:w-32 md:h-44 shrink-0 rounded-md overflow-hidden bg-background-200">
                  <img
                    src={pick.cover}
                    alt={`${pick.title} 漫画封面`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex flex-col justify-center">
                  <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                    {pick.title}
                  </h3>
                  <p className="mt-1 text-sm font-label text-foreground-500">
                    {pick.author}
                  </p>
                  <span className="mt-2 w-fit px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-800 text-xs font-label">
                    {pick.category}
                  </span>
                  <p className="mt-3 text-xs font-label text-foreground-500">
                    {pick.readTime}
                  </p>
                </div>
              </div>

              <div
                className={`md:col-span-8 flex flex-col justify-center ${
                  index % 2 === 1 ? "md:order-1" : ""
                }`}
              >
                <span className="font-heading text-4xl md:text-5xl font-black text-background-300 leading-none">
                  0{index + 1}
                </span>
                <p className="mt-4 text-sm md:text-base text-foreground-700 leading-loose">
                  {pick.note}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}